import React from 'react';
import './ScrollingBanner.css';

const ScrollingBanner = ({ text, backgroundColor, textColor = 'white', fontSize = '1.1rem' }) => {
  return (
    <div 
      className="scrolling-banner"
      style={{ backgroundColor:  backgroundColor }}
    >
      <div className="scrolling-text">
        <span style={{ color: textColor, fontSize: fontSize }}>{text}</span>
        <span style={{ color: textColor, fontSize: fontSize }}>{text}</span>
        <span style={{ color: textColor, fontSize: fontSize }}>{text}</span>
      </div>
    </div>
  );
};

export default ScrollingBanner;